import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Phase 1: /register is now a redirect to the new /onboarding wizard.
// Incoming utm_* (and any other) query params are preserved so analytics
// links continue to work. We use a client-side useEffect redirect rather
// than <Navigate /> so that SSR pre-rendering can produce a stable HTML
// shell without warnings.
export default function Register() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const target = `/onboarding${location.search || ""}`;
    navigate(target, { replace: true });
  }, [navigate, location.search]);

  // Minimal SSR-friendly fallback while the redirect runs on the client.
  return (
    <div
      className="paper-bg"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "var(--f-body)",
        color: "var(--ink-soft)",
      }}
    >
      <p>Weiterleitung …</p>
    </div>
  );
}
